import {
  AgreementKindEnum,
  type Agreements,
  type EnabledAgreements,
} from '../agreement';
import { SearchParameters } from '../searchParameters';

/**
 * The agreement per kind the current search points at — a filter-value match
 * only, with no ownership or availability check.
 *
 * Lives here rather than on `Agreements` because it takes the search too, and
 * the agreement and search-parameter domains stay independent of each other.
 */
export const getEnabledAgreements = (
  agreements: Agreements,
  searchParameters: SearchParameters
): EnabledAgreements => {
  const selection = searchParameters.agreements;
  if (!selection) return {};

  return {
    paAgreement: agreements.ofKind(
      selection.premiumaccess,
      AgreementKindEnum.PA
    ),
    eaAgreement: agreements.ofKind(selection.easyaccess, AgreementKindEnum.EA),
    edAgreement: agreements.ofKind(
      selection.editorialsubscription,
      AgreementKindEnum.ED
    ),
    rfAgreement: agreements.ofKind(
      selection.royaltyfreesubscription,
      AgreementKindEnum.RF
    ),
  };
};
